import React from 'react';
import { Box, Typography } from '@material-ui/core';
import EmptyImage from './emptyTracking.svg';
import { useEmptyStateStyles } from './styles';

const TrackingEmptyState = () => {
  const classes = useEmptyStateStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignContent="center"
      alignItems="center"
      paddingBottom="40px"
    >
      <img className={classes.image} src={EmptyImage} />
      <Typography variant="h5">
        Por el momento no podemos mostrar el seguimiento de tu compra
      </Typography>
    </Box>
  );
};

export default TrackingEmptyState;
